import { reactive, watchEffect } from 'vue'

export const AkzentFarben = [
  { Name: 'Grün',   Wert: '#3DA568' },
  { Name: 'Orange', Wert: '#E07B2A' },
  { Name: 'Blau',   Wert: '#4A7DDE' },
  { Name: 'Lila',   Wert: '#8B5CF6' },
  { Name: 'Rosa',   Wert: '#D9548C' }
]

const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

export const theme = reactive({
  mode: prefersDark ? 'dark' : 'light',
  accent: AkzentFarben[0].Wert
})

export function setMode(mode) {
  theme.mode = mode
}

export function setAccent(Wert) {
  theme.accent = Wert
}

// Kompatibilität zu gespeicherten Profilen: nur die Akzentfarbe wird noch übernommen,
// alle übrigen Farben sind fest im Glass-Design verankert (global.css, data-theme)
export function setColor(key, value) {
  if (key === 'primary' && value) {
    theme.accent = value
  }
}

// Payload für profilSpeichern.php – Feldnamen bleiben wie im Backend-Schema
export function ThemeProfilDaten() {
  const Dunkel = theme.mode === 'dark'
  return {
    Modus: Dunkel ? 'Dunkel' : 'Hell',
    Hintergrundfarbe: Dunkel ? '#131311' : '#F6F4EF',
    HintergrundfarbeLeiste: Dunkel ? '#1D1C19' : '#FFFFFF',
    Textfarbe: Dunkel ? '#F0EDE8' : '#1A1A18',
    Akzentfarbe: theme.accent,
    Rahmenfarbe: Dunkel ? '#3A3830' : '#E4E2DC'
  }
}

export function initTheme() {
  watchEffect(() => {
    const root = document.documentElement
    root.dataset.theme = theme.mode
    root.style.setProperty('--color-primary', theme.accent)
  })
}
